import { ISelectOption } from 'app/interfaces/ISelectOption';

export enum SSLMode {
    Disable = 'disable',
    Allow = 'allow',
    Prefer = 'prefer',
    Require = 'require',
    VerifyCa = 'verify-ca',
    VerifyFull = 'verify-full'  // default
}

export const sslModeOptions: Array<ISelectOption<SSLMode>> = [
    {
        label: stringResources.SSL_Mode_Verify_Full,
        value: SSLMode.VerifyFull
    },
    {
        label: stringResources.SSL_Mode_Verify_Ca,
        value: SSLMode.VerifyCa
    },
    {
        label: stringResources.Required,
        value: SSLMode.Require
    },
    {
        label: stringResources.SSL_Mode_Preferred,
        value: SSLMode.Prefer
    },
    {
        label: stringResources.SSL_Mode_Allowed,
        value: SSLMode.Allow
    },
    {
        label: stringResources.Disabled,
        value: SSLMode.Disable
    },
    
];